module.exports = __webpack_public_path__ + "media/images/posts/flower_pots-9c84901fceab7d70db22a30bd558d0ff.jpg";